import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useHistory } from "react-router";
import _ from "lodash";
import { useSelector } from "react-redux";
import NotificationMessage from "../../utils/NotificationMessage";
import MainDeposit from "./components/MainDeposit";
import * as userSelectors from "../../selectors/user";
import * as authSelectors from "../../selectors/auth";
import { withDepositConfig } from "../../hooks/withDepositConfig";
import * as depositSelectors from "../../selectors/e-deposit";
import NotificationManager from "../../utils/NotificationMessage";
import * as paymentSelectors from "../../selectors/payment";
import {getDepositConfigAttributes} from "../../selectors/e-deposit";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faWarning } from "@fortawesome/free-solid-svg-icons";
import GeneralPaymentDisclaimerRemark from "../EPayment/GeneralPaymentDisclaimerRemark";
const paymentMethods = [
  { label: "FPX Online Transfer", value: "deposit-fpx-transfer" },
  { label: "Manual Transfer", value: "deposit-manual" },
];

function EDeposit({ depositConfig }) {
  let history = useHistory();
  const [selectedOption, setSelectedOption] = useState("");
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const userState = useSelector((state) => state.user);
  const accountSelections = userSelectors.getUserAccountSelections(userState);
  const accountValue = userSelectors.getUserAccountText(userSelectors.getUserAccountIsSelected(userState));
  const currenciesSelections = userSelectors.getUserAccountIsSelectedCurrencies(userState);
  const currenciesKey = userSelectors.getUserAccountCurrencySelectedObject(userState);
  const [selectedAccountId, setSelectedAccountId] = useState(accountValue);
  const [selectedCurrencyId, setSelectedCurrency] = useState(currenciesKey);
  useEffect(() => {
    const selectedAccountValue = userSelectors.getUserAccountText(
      userSelectors.getUserAccountIsSelected(userState),
    );
    const selectedCurrenciesKey = userSelectors.getUserAccountCurrencySelectedObject(userState);
    const manualPayment = depositSelectors.getDepositManualPaymentSupportedCurrencies(depositConfig);
    const onlinePayment = depositSelectors.getDepositOnlinePaymentSupportedCurrencies(depositConfig);
    if (_.some(onlinePayment, _.matchesProperty("value", selectedCurrencyId && selectedCurrencyId.key))) {
      setSelectedOption("deposit-fpx-transfer");
    } else if (
      _.some(manualPayment, _.matchesProperty("value", selectedCurrencyId && selectedCurrencyId.key))
    ) {
      setSelectedOption("deposit-manual");
    }
    setSelectedAccountId(selectedAccountValue);
    setSelectedCurrency(selectedCurrenciesKey);
  }, [userState, depositConfig]);

  // For currency check
  const manualCurrencyCheck = depositSelectors.getDepositManualPaymentSupportedCurrencies(depositConfig);
  const onlineCurrencyCheck = depositSelectors.getDepositOnlinePaymentSupportedCurrencies(depositConfig);
  const attributes = depositSelectors.getDepositConfigAttributes(depositConfig);
  const isDepositOperate = _.get(attributes, ["is_operate"], []);
  const startTime = _.get(attributes, ["start_time"], []);
  const cutOffTime = _.get(attributes, ["cutoff_time"], []);

  const handleGoBack = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const handleRadioChange = (value) => {
    setSelectedOption(value);
  };

  const handleContinue = () => {
    if (!isDepositOperate) {
      NotificationManager.error(`Operation Hours ${startTime} - ${cutOffTime}. Please try again by tomorrow.`);
    } else if (selectedAccountId) {
      history.push({
        pathname: `/dashboard/${selectedOption}`,
        state: {
          selectedAccountId,
          selectedOption,
          selectedCurrencyId,
        },
      });
    }
  };

  // const handleContinue = () => {
  //   if (!selectedOption) {
  //     NotificationMessage.error("Please select payment method");
  //   } else if (selectedOption === "deposit-fpx-transfer") {
  //     if (!onlineCurrencyCheck) {
  //       NotificationMessage.error("Currency does not support");
  //       return;
  //     }
  //   } else if (selectedOption === "deposit-manual") {
  //     if (!manualCurrencyCheck) {
  //       NotificationMessage.error("Currency does not support");
  //       return;
  //     }
  //   }
  //   history.push({
  //     pathname: `/dashboard/${selectedOption}`,
  //     state: {
  //       accountId: selectedAccountId,
  //       selectedCurrencyId,
  //     },
  //   });
  // };

  const handleAccountChange = (e) => {
    setSelectedAccountId(e.target.value);
  };
  const handleCurrencyChange = (e) => {
    setSelectedCurrency(_.find(currenciesSelections, (item) => _.isEqual(item.key, e.target.value)));
  };

  return (
    <div className="container-fluid">
      {!isDepositOperate ? (
          <Alert key="info" variant="secondary" sx={{ borderRadius: '5px' }}>
            <div style={{ color: "#2c2c2c" }}>
                <span className={"text-bold-600"}>
                  <FontAwesomeIcon
                      icon={faCircleExclamation}
                      color="#2c2c2c"
                      size="xl"
                      style={{marginRight: 10}}
                  ></FontAwesomeIcon>
                  {`Our facility temporary was not available now.`}
                </span>
            </div>
          </Alert>
      ) : ( false )}
      <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
        <div className={clsx("custom-card-label-container text-center")}>
          <h2>Deposit</h2>
        </div>
        <br />
        <MainDeposit
          config={depositConfig}
          accountSelections={accountSelections}
          currenciesSelections={currenciesSelections}
          selectedAccountId={selectedAccountId}
          selectedCurrencyId={selectedCurrencyId}
          handleAccountChange={handleAccountChange}
          handleCurrencyChange={handleCurrencyChange}
          paymentMethods={paymentMethods}
          selectedOption={selectedOption}
          handleRadioChange={handleRadioChange}
          handleGoBack={handleGoBack}
          handleContinue={handleContinue}
          onlineCurrencyCheck={onlineCurrencyCheck}
          manualCurrencyCheck={manualCurrencyCheck}
          isDepositOperate={isDepositOperate}
        />
      </div>
      <GeneralPaymentDisclaimerRemark></GeneralPaymentDisclaimerRemark>
    </div>
  );
}

export default withDepositConfig(EDeposit);
